<template>
  <div>
    <el-card class="box-card">
      <el-form :inline="true">
        <el-form-item label="市场">
          <el-select v-model="marketStatus" clearable style='width: 200px;' placeholder="请选择">
            <el-option v-for="(item, index) in $key.common.market" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值日期" span="2" style="margin-left: 20px;">
          <el-date-picker
            clearable
            v-model="leftApplyDate"
            type="date"
            placeholder="开始日期">
          </el-date-picker>
          -
          <el-date-picker
            clearable
            style="margin-right: 15px;"
            v-model="rightApplyDate"
            type="date"
            placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 10px;">
          <el-button type="primary" @click="handleSearch"><i class="fa fa-search"> 查询</i>
          </el-button>
          <el-button type="primary" plain @click="handleReset"><i class="fa fa-refresh"> 重置</i>
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 导出 -->
    <inquery-result style="margin-bottom: 20px;" :isExport='false'></inquery-result>
    <el-table ref="zTable" :data="tableData">
      <el-table-column prop="marketName" label="市场" align="center"></el-table-column>
      <el-table-column prop="applyCode" label="充值单号" align="center"></el-table-column>
      <el-table-column prop="bankOrderNo" label="银行流水单号" align="center"></el-table-column>
      <el-table-column prop="subsidiaryAccountNo" label="附属账号" align="center" :formatter='subsidiaryAccount'></el-table-column>
      <el-table-column prop="subsidiaryAccountName" label="附属账户名" align="center"></el-table-column>
      <el-table-column prop="payerBankCardNum" label="付款方账号" align="center" :formatter='payerBankCardNum'></el-table-column>
      <el-table-column prop="payerBankAccName" label="付款方账户名" align="center"></el-table-column>
      <el-table-column prop="" label="充值金额（元）" align="center">
        <template slot-scope="scope">
          <span>
            {{scope.row.rechargeAmount | thousandMark}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="rechargeDate" label="充值时间" align="center"></el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout='total, prev, pager, next'
      :current-page.sync="currentPage"
      :total='total'
      @current-change="changePage"
      background>
    </el-pagination>
  </div>
</template>

<script>
import api from '@/api'
import { formatTime } from '@/utils/util'
export default {
  components: {
  },
  data () {
    return {
      // 市场状态
      marketStatus: '',
      // 附属账号
      subsidiaryAccountNo: '',
      // 充值日期
      leftApplyDate: '',
      rightApplyDate: '',
      // 列表信息
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 10
    }
  },

  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 查询
    handleSearch () {
      this.fetchList(1)
    },
    // 重置
    handleReset () {
      this.marketStatus = ''
      this.subsidiaryAccountNo = ''
      this.leftApplyDate = ''
      this.rightApplyDate = ''
      this.fetchList(1)
    },
    // 获取列表数据
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        marketId: this.marketStatus,
        bankCode: 'WHZBANK',
        leftApplyDate: formatTime(this, this.leftApplyDate),
        rightApplyDate: formatTime(this, this.rightApplyDate, 1),
        currentNo: this.currentNo,
        pageSize: this.pageSize
      }

      let res = await api.myAccount.rechargeList(param)
      this.tableData = res.data.rows
      this.total = res.data.totalElements
    },
    // 附属账号
    subsidiaryAccount (row) {
      return row.subsidiaryAccountNo.replace(/\s/g, '').replace(/(.{4})/g, '$1 ')
    },
    // 付款方账号
    payerBankCardNum (row) {
      return row.payerBankCardNum.replace(/\s/g, '').replace(/(.{4})/g, '$1 ')
    },
    // 分页
    changePage (page) {
      this.fetchList(page)
    }
  }
}
</script>

<style lang="scss" scoped>
  .pagination {
    margin: 20px 0 20px 0;
    float: right;
  }
  ::v-deep .table-page-search-submitButtons{
    margin-left: 100px
  }
</style>
